/** FilterTabs — controlled tab bar for filtering a list/table view. */
import type { ReactNode } from 'react';
import { Tab, Tabs } from '@mui/material';

interface FilterTabItem {
  key: string;
  /** ReactNode so a tab can carry a trailing indicator, not just a string. */
  label: ReactNode;
}

interface FilterTabsProps {
  tabs: FilterTabItem[];
  active: string;
  onChange: (key: string) => void;
  ariaLabel?: string;
}

export function FilterTabs({ tabs, active, onChange, ariaLabel }: FilterTabsProps) {
  return (
    <Tabs
      value={active}
      onChange={(_event, value: string) => onChange(value)}
      aria-label={ariaLabel}
      sx={{ minHeight: 36 }}
    >
      {tabs.map((tab) => (
        <Tab key={tab.key} value={tab.key} label={tab.label} sx={{ minHeight: 36, py: 0.5 }} />
      ))}
    </Tabs>
  );
}
